import { render, staticRenderFns } from "./SipCallData.vue?vue&type=template&id=51352578"
import script from "./SipCallData.vue?vue&type=script&lang=js"
export * from "./SipCallData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports